class PdpProductDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab-id]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel-id]'));
    this.indicators = Array.from(this.querySelectorAll('[data-pdp-indicator]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tabId));
    });

    if (this.tabs.length) this.activate(this.tabs[0].dataset.tabId);
  }

  activate(id) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle('pdp-nav-item--active', tab.dataset.tabId === id);
      tab.setAttribute('aria-selected', tab.dataset.tabId === id);
    });

    this.panels.forEach((panel) => {
      panel.toggleAttribute('hidden', panel.dataset.panelId !== id);
    });

    this.indicators.forEach((indicator) => {
      const nav = indicator.closest('[data-pdp-nav]');
      const activeTab = nav.querySelector(`[data-tab-id="${CSS.escape(id)}"]`);
      if (!activeTab) return;

      indicator.style.transform = `translateX(${activeTab.offsetLeft}px)`;
      indicator.style.width = `${activeTab.offsetWidth}px`;
    });
  }
}

customElements.define('pdp-product-details-tabs', PdpProductDetailsTabs);
